import { useCallback, useRef, useState } from 'react';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useWatchEquipmentSelection } from '@/feature/chatbot/useWatchEquipmentSelection';
import env from '@/util/env';
import { ChatbotButton } from './ChatbotButton';
import { ChatWindow } from './ChatWindow';

export const ChatbotContainer = () => {
  if (!env.CHATBOT_ENABLED) {
    return null;
  }

  return <Chatbot />;
};

const Chatbot = () => {
  const { isAvailable, isOpen, setIsOpen } = useChatbot();
  const [customWidth, setCustomWidth] = useState<number | undefined>(undefined);
  const [customHeight, setCustomHeight] = useState<number | undefined>(
    undefined
  );
  const chatWindowRef = useRef<HTMLDivElement>(null);
  useWatchEquipmentSelection();

  const handleResize = useCallback((width: number, height: number) => {
    setCustomWidth(width);
    setCustomHeight(height);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setCustomWidth(undefined);
    setCustomHeight(undefined);
  }, [setIsOpen]);

  if (!isAvailable) {
    return null;
  }

  return (
    <>
      {isOpen ? (
        <ChatWindow
          ref={chatWindowRef}
          onClose={handleClose}
          customWidth={customWidth}
          customHeight={customHeight}
          onResize={handleResize}
        />
      ) : (
        <ChatbotButton onClick={() => setIsOpen(true)} />
      )}
    </>
  );
};
